import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { CustomStore, BreezeDxStoreService, AuthService, GenesisUnitOfWork, MessageService, PartPurchaseRepository } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { EntityQuery } from 'breeze-client';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { Subscription } from 'rxjs';
import { PartPurchaseDialogComponent } from 'app/shared/part-purchase-dialog/part-purchase-dialog.component';
import { Part, PartPurchase, PartPurchaseAttachment } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-part-purchases',
    templateUrl: './part-purchases.component.html',
    styleUrls: ['./part-purchases.component.scss'],
    standalone: false
})
export class PartPurchasesComponent implements OnInit {
    purchases: any;
    orders: any[];
    showAllOrders = false;
    filter: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        public auth: AuthService,
        private partPurchaseRepository: PartPurchaseRepository
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        const purchases = (await this.uow.getPartPurchases()) as PartPurchase[];
        purchases.forEach((purchase: any) => {
            purchase.attachmentsHTML = purchase.partPurchaseAttachments
                .filter((attachment: PartPurchaseAttachment) => !attachment.deleted)
                .map((attachment: PartPurchaseAttachment) => `<a href="${attachment.filename}" target="_blank">${attachment.name}</a>`)
                .join('<br/>');
        });
        this.purchases = purchases;
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async addPartPurchase(selectedPartPurchase?: any) {
        if (await this.partPurchaseRepository.addPartPurchase(selectedPartPurchase ? selectedPartPurchase.part : null)) {
            await this.getData();
        }
    }
}
